"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.actionTypes = void 0;
var actionTypes = {
  COOKIE_STATUS: "@@analytic-session/cookie-status",
  ADD_SESSION_SITE: "@@analytic-session/add-session-site",
  ADD_SESSION_REPORT: "@@analytic-session/add-session-report",
  ADD_SESSION_SURVEY: "@@analytic-session/add-session-survey",
  INITIAL_SESSION_SITE: "@@analytic-session/initial-session-site",
  INITIAL_SESSION_REPORT: "@@analytic-session/initial-session-report",
  INITIAL_SESSION_SURVEY: "@@analytic-session/initial-session-survey",
  DELETE: "@@analytic-session/delete-sessio",
  FETCH_RECORDING: "@@analytic-session/fetch-recording",
  RESET: "@@analytic-session/reset",
  SUCCESS: "@@analytic-session/success",
  ERROR: "@@analytic-session/error"
};
exports.actionTypes = actionTypes;